// Mock Traceability Data - SmartTrace Simulation
// 8 lots fictifs avec différents statuts

export const mockLots = {
  // LOT 1: Mangues Kent - VERIFIED (Vérifié)
  'OCN-MK-2024-001': {
    code: 'OCN-MK-2024-001',
    status: 'verified',
    product: {
      name: { fr: 'Mangue Kent', en: 'Kent Mango' },
      variety: 'Kent',
      category: { fr: 'Fruits Tropicaux', en: 'Tropical Fruits' },
      image: 'https://images.unsplash.com/photo-1553279768-865429fa0078?w=400'
    },
    origin: {
      country: { fr: 'Côte d\'Ivoire', en: 'Côte d\'Ivoire' },
      region: 'Korhogo',
      producer: 'Coopérative Mangues du Nord',
      harvestDate: '2024-03-15'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Korhogo', en: 'Harvest - Korhogo' },
        date: '2024-03-15',
        temperature: '28°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Pack House Sinématiali', en: 'Sinématiali Pack House' },
        date: '2024-03-16',
        temperature: '12°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-17',
        temperature: '10°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Mûrisserie', en: 'Ripening Room' },
        date: '2024-03-18',
        temperature: '18°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Livraison GMS', en: 'Retail Delivery' },
        date: '2024-03-20',
        temperature: '8°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'Rainforest Alliance'],
    qualityScore: 95,
    expiryDate: '2024-03-30',
    packaging: { fr: 'Carton 6kg', en: '6kg Box' }
  },

  // LOT 2: Ananas Sweet - VERIFIED
  'OCN-AN-2024-002': {
    code: 'OCN-AN-2024-002',
    status: 'verified',
    product: {
      name: { fr: 'Ananas Sweet', en: 'Sweet Pineapple' },
      variety: 'MD2 Sweet',
      category: { fr: 'Fruits Tropicaux', en: 'Tropical Fruits' },
      image: 'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=400'
    },
    origin: {
      country: { fr: 'Côte d\'Ivoire', en: 'Côte d\'Ivoire' },
      region: 'Tiassalé',
      producer: 'Plantation Ananas de Tiassalé',
      harvestDate: '2024-03-10'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Tiassalé', en: 'Harvest - Tiassalé' },
        date: '2024-03-10',
        temperature: '30°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Centre de tri', en: 'Sorting Center' },
        date: '2024-03-10',
        temperature: '15°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-11',
        temperature: '10°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Livraison Point de Vente', en: 'Store Delivery' },
        date: '2024-03-12',
        temperature: '8°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'BIO'],
    qualityScore: 98,
    expiryDate: '2024-03-25',
    packaging: { fr: 'Carton 10 pièces', en: '10-piece Box' }
  },

  // LOT 3: Bananes Cavendish - VERIFIED
  'OCN-BN-2024-003': {
    code: 'OCN-BN-2024-003',
    status: 'verified',
    product: {
      name: { fr: 'Banane Cavendish', en: 'Cavendish Banana' },
      variety: 'Cavendish',
      category: { fr: 'Fruits Tropicaux', en: 'Tropical Fruits' },
      image: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=400'
    },
    origin: {
      country: { fr: 'Côte d\'Ivoire', en: 'Côte d\'Ivoire' },
      region: 'Aboisso',
      producer: 'SCB - Compagnie Fruitière',
      harvestDate: '2024-03-08'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Aboisso', en: 'Harvest - Aboisso' },
        date: '2024-03-08',
        temperature: '26°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Station d\'emballage', en: 'Packing Station' },
        date: '2024-03-08',
        temperature: '14°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Transport réfrigéré', en: 'Refrigerated Transport' },
        date: '2024-03-09',
        temperature: '13°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Mûrisserie Océana', en: 'Océana Ripening Room' },
        date: '2024-03-10',
        temperature: '17°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Distribution', en: 'Distribution' },
        date: '2024-03-14',
        temperature: '14°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'Fairtrade'],
    qualityScore: 92,
    expiryDate: '2024-03-24',
    packaging: { fr: 'Carton 18kg', en: '18kg Box' }
  },

  // LOT 4: Pommes Golden - VERIFIED (Origine Europe)
  'OCN-PG-2024-004': {
    code: 'OCN-PG-2024-004',
    status: 'verified',
    product: {
      name: { fr: 'Pomme Golden', en: 'Golden Apple' },
      variety: 'Golden Delicious',
      category: { fr: 'Fruits', en: 'Fruits' },
      image: 'https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=400'
    },
    origin: {
      country: { fr: 'France', en: 'France' },
      region: 'Lot-et-Garonne',
      producer: 'Vergers du Sud-Ouest',
      harvestDate: '2024-02-20'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Lot-et-Garonne', en: 'Harvest - Lot-et-Garonne' },
        date: '2024-02-20',
        temperature: '8°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Hub Europe - Boulogne-sur-Gesse', en: 'Europe Hub - Boulogne-sur-Gesse' },
        date: '2024-02-21',
        temperature: '2°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Conteneur frigorifique', en: 'Refrigerated Container' },
        date: '2024-02-25',
        temperature: '1°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Port d\'Abidjan', en: 'Abidjan Port' },
        date: '2024-03-05',
        temperature: '2°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-06',
        temperature: '2°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'HVE (Haute Valeur Environnementale)'],
    qualityScore: 97,
    expiryDate: '2024-04-15',
    packaging: { fr: 'Carton 13kg', en: '13kg Box' }
  },

  // LOT 5: Oranges Navel - VERIFIED (Origine Afrique du Sud)
  'OCN-OR-2024-005': {
    code: 'OCN-OR-2024-005',
    status: 'verified',
    product: {
      name: { fr: 'Orange Navel', en: 'Navel Orange' },
      variety: 'Navel',
      category: { fr: 'Agrumes', en: 'Citrus' },
      image: 'https://images.unsplash.com/photo-1547514701-42782101795e?w=400'
    },
    origin: {
      country: { fr: 'Afrique du Sud', en: 'South Africa' },
      region: 'Western Cape',
      producer: 'Citrus Growers Association',
      harvestDate: '2024-02-10'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Western Cape', en: 'Harvest - Western Cape' },
        date: '2024-02-10',
        temperature: '22°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Hub Stellenbosch', en: 'Stellenbosch Hub' },
        date: '2024-02-11',
        temperature: '4°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Conteneur frigorifique', en: 'Refrigerated Container' },
        date: '2024-02-15',
        temperature: '3°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Port d\'Abidjan', en: 'Abidjan Port' },
        date: '2024-03-01',
        temperature: '4°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Distribution GMS', en: 'Retail Distribution' },
        date: '2024-03-03',
        temperature: '6°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'SIZA'],
    qualityScore: 94,
    expiryDate: '2024-04-01',
    packaging: { fr: 'Carton 15kg', en: '15kg Box' }
  },

  // LOT 6: Raisin Crimson - VERIFIED (Origine Inde via UAE)
  'OCN-RC-2024-006': {
    code: 'OCN-RC-2024-006',
    status: 'verified',
    product: {
      name: { fr: 'Raisin Crimson', en: 'Crimson Grapes' },
      variety: 'Crimson Seedless',
      category: { fr: 'Fruits', en: 'Fruits' },
      image: 'https://images.unsplash.com/photo-1537640538966-79f369143f8f?w=400'
    },
    origin: {
      country: { fr: 'Inde', en: 'India' },
      region: 'Maharashtra',
      producer: 'Nashik Valley Growers',
      harvestDate: '2024-02-28'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Nashik, Inde', en: 'Harvest - Nashik, India' },
        date: '2024-02-28',
        temperature: '24°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Centre d\'emballage', en: 'Packing Center' },
        date: '2024-02-28',
        temperature: '2°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Hub Ajman, UAE', en: 'Ajman Hub, UAE' },
        date: '2024-03-03',
        temperature: '0°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Port d\'Abidjan', en: 'Abidjan Port' },
        date: '2024-03-12',
        temperature: '1°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-13',
        temperature: '2°C',
        status: 'completed'
      }
    ],
    certifications: ['GlobalGAP', 'IndGAP'],
    qualityScore: 91,
    expiryDate: '2024-03-28',
    packaging: { fr: 'Carton 4.5kg', en: '4.5kg Box' }
  },

  // LOT 7: Papayes Formosa - RECALLED (Rappelé)
  'OCN-PP-2024-007': {
    code: 'OCN-PP-2024-007',
    status: 'recalled',
    recallReason: {
      fr: 'Traces de résidus de pesticides détectées au-dessus des seuils autorisés. Lot retiré par mesure de précaution.',
      en: 'Pesticide residue traces detected above authorized thresholds. Lot withdrawn as a precautionary measure.'
    },
    recallDate: '2024-03-18',
    product: {
      name: { fr: 'Papaye Formosa', en: 'Formosa Papaya' },
      variety: 'Formosa',
      category: { fr: 'Fruits Tropicaux', en: 'Tropical Fruits' },
      image: 'https://images.unsplash.com/photo-1517282009859-f000ec3b26fe?w=400'
    },
    origin: {
      country: { fr: 'Brésil', en: 'Brazil' },
      region: 'Bahia',
      producer: 'Fazenda Tropical',
      harvestDate: '2024-02-25'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Bahia, Brésil', en: 'Harvest - Bahia, Brazil' },
        date: '2024-02-25',
        temperature: '28°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Centre d\'emballage', en: 'Packing Center' },
        date: '2024-02-26',
        temperature: '10°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Transport maritime', en: 'Sea Transport' },
        date: '2024-03-01',
        temperature: '8°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-15',
        temperature: '10°C',
        status: 'flagged'
      }
    ],
    certifications: ['GlobalGAP'],
    qualityScore: 45,
    expiryDate: '2024-03-28',
    packaging: { fr: 'Carton 12kg', en: '12kg Box' }
  },

  // LOT 8: Avocats Hass - VERIFIED (En cours de livraison)
  'OCN-AV-2024-008': {
    code: 'OCN-AV-2024-008',
    status: 'verified',
    product: {
      name: { fr: 'Avocat Hass', en: 'Hass Avocado' },
      variety: 'Hass',
      category: { fr: 'Fruits', en: 'Fruits' },
      image: 'https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=400'
    },
    origin: {
      country: { fr: 'Kenya', en: 'Kenya' },
      region: 'Murang\'a',
      producer: 'Kenya Avocado Growers',
      harvestDate: '2024-03-05'
    },
    journey: [
      {
        step: 1,
        location: { fr: 'Récolte - Murang\'a, Kenya', en: 'Harvest - Murang\'a, Kenya' },
        date: '2024-03-05',
        temperature: '22°C',
        status: 'completed'
      },
      {
        step: 2,
        location: { fr: 'Centre de tri Nairobi', en: 'Nairobi Sorting Center' },
        date: '2024-03-06',
        temperature: '6°C',
        status: 'completed'
      },
      {
        step: 3,
        location: { fr: 'Fret aérien', en: 'Air Freight' },
        date: '2024-03-07',
        temperature: '5°C',
        status: 'completed'
      },
      {
        step: 4,
        location: { fr: 'Hub Froid Abidjan', en: 'Abidjan Cold Hub' },
        date: '2024-03-08',
        temperature: '5°C',
        status: 'completed'
      },
      {
        step: 5,
        location: { fr: 'Mûrisserie', en: 'Ripening Room' },
        date: '2024-03-09',
        temperature: '16°C',
        status: 'in_progress'
      }
    ],
    certifications: ['GlobalGAP', 'KenyaGAP'],
    qualityScore: 96,
    expiryDate: '2024-03-22',
    packaging: { fr: 'Carton 4kg', en: '4kg Box' }
  }
};

/**
 * Recherche un lot par son code
 * @param {string} code - Le code du lot (ex: OCN-MK-2024-001)
 * @returns {Object|null} - Les données du lot ou null si non trouvé
 */
export const getLotByCode = (code) => {
  const normalizedCode = code?.trim().toUpperCase();
  return mockLots[normalizedCode] || null;
};

/**
 * Vérifie si un code de lot existe
 * @param {string} code - Le code du lot
 * @returns {boolean}
 */
export const lotExists = (code) => {
  const normalizedCode = code?.trim().toUpperCase();
  return normalizedCode in mockLots;
};

/**
 * Retourne tous les lots (pour admin/debug)
 * @returns {Object}
 */
export const getAllLots = () => mockLots;

/**
 * Retourne un exemple de code pour l'interface
 * @returns {string}
 */
export const getExampleCode = () => 'OCN-MK-2024-001';

export default {
  mockLots,
  getLotByCode,
  lotExists,
  getAllLots,
  getExampleCode
};
